import { useState } from "react"

//PrimeReact
import { Accordion, AccordionTab } from "primereact/accordion"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"

//Housing Styles and components
import myStyle from "../../../styles/housing/HousingRent.module.css"
import { useEffect } from "react"

export default function HousingRentFilter({
  participants,
  participant,
  onSetParticipant,
  isLoading,
  houseList,
  onRefreshClick,
  onChangeFilters,
  onNewChargeClick,
}) {
  const [houseId, setHouseId] = useState("")
  const [status, setStatus] = useState("Due")
  const [fromDate, setFromDate] = useState(undefined)
  const [toDate, setToDate] = useState(new Date())
  const [filterParticipant, setFilterParticipant] = useState(undefined)

  useEffect(() => {
    setFilterParticipant(participant)
  }, [participant])

  const FilterHeader = () => {
    return (
      <div className={myStyle.filterHeaderGridContainer}>
        <div className={myStyle.filterHeaderGridTitle}>
          <label>{"Filters"}</label>
        </div>
        <div className={myStyle.filterHeaderGridButtons}>
          <div className={myStyle.filterButtonContainer}>
            {!!onRefreshClick ? (
              <button
                type="button"
                className={`btn t-tip ${myStyle.filterHeaderButton}`}
                onClick={(e) => {
                  e.stopPropagation()
                  if (!!onRefreshClick) {
                    onRefreshClick()
                  }
                }}
                disabled={isLoading}
              >
                <span className={`material-icons`}>{"autorenew"}</span>
                {" Reload data"}
              </button>
            ) : null}
            <button
              type="button"
              className={`btn t-tip ${myStyle.filterHeaderButton}`}
              onClick={(e) => {
                e.stopPropagation()
                if (!!onNewChargeClick) {
                  onNewChargeClick()
                }
              }}
              disabled={isLoading}
            >
              <span className={`material-icons`}>{"add"}</span>
              {" Add new charge"}
            </button>
          </div>
        </div>
      </div>
    )
  }
  return (
    <>
      <Accordion style={{ marginBottom: "10px" }} activeIndex={0}>
        <AccordionTab
          header={FilterHeader()}
          disabled={isLoading}
          headerClassName={myStyle.filterHeader}
        >
          <div className={myStyle.filterBodyGridContainer}>
            <div className={myStyle.filterBodyGridHouse}>
              <div className={myStyle.label}>House</div>
              <div>
                <Dropdown
                  className={myStyle.input}
                  value={houseId}
                  onChange={(e) => {
                    setHouseId(e.value)
                  }}
                  placeholder="All houses"
                  options={houseList}
                  optionLabel={"name"}
                  optionValue={"id"}
                  disabled={isLoading}
                  filter
                />
              </div>
            </div>
            <div className={myStyle.filterBodyGridType}>
              <div className={myStyle.label}>Status</div>
              <div>
                <Dropdown
                  className={myStyle.input}
                  options={["Due", "All"]}
                  value={status}
                  onChange={(e) => {
                    setStatus(e.value)
                  }}
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className={myStyle.filterBodyGridFrom}>
              <div className={myStyle.label}>From Date</div>
              <div>
                <Calendar
                  className={myStyle.input}
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.value)
                  }}
                  maxDate={toDate}
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className={myStyle.filterBodyGridTo}>
              <div className={myStyle.label}>To Date</div>
              <div>
                <Calendar
                  className={myStyle.input}
                  value={toDate}
                  onChange={(e) => {
                    setToDate(e.value)
                  }}
                  minDate={fromDate}
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className={myStyle.filterBodyGridParticipants}>
              <div className={myStyle.label}>Participant</div>
              <Dropdown
                className={myStyle.input}
                value={filterParticipant}
                onChange={(e) => {
                  if (!!e.value.participant_id) {
                    setFilterParticipant(e.value)
                  } else {
                    setFilterParticipant(undefined)
                  }
                }}
                placeholder="All participants"
                options={[{ name2: "All participants" }, ...participants]}
                optionLabel={"name2"}
                disabled={isLoading}
                filter
              />
            </div>
            <div className={myStyle.filterBodyGridButtons}>
              <div className={myStyle.filterButtons}>
                <button
                  className="btn"
                  type="button"
                  onClick={() => {
                    onChangeFilters({
                      status: status,
                      houseId: houseId,
                      fromDate: fromDate,
                      toDate: toDate,
                      participantId: filterParticipant?.participant_id,
                    })
                    onSetParticipant(filterParticipant)
                  }}
                  disabled={isLoading}
                >
                  Apply
                </button>
                <button
                  className={`btn ${myStyle.filterButton}`}
                  type="button"
                  onClick={() => {
                    setStatus("Due")
                    setHouseId(undefined)
                    setFromDate(undefined)
                    setToDate(new Date())
                    setFilterParticipant(undefined)
                    onChangeFilters({
                      status: "Due",
                      houseId: undefined,
                      fromDate: undefined,
                      toDate: new Date(),
                      participantId: undefined,
                    })

                    if (!!participant) {
                      onSetParticipant(undefined)
                    }
                  }}
                  disabled={isLoading}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    </>
  )
}
